import { render, staticRenderFns } from "./Barrage.vue?vue&type=template&id=0b2e6036&scoped=true&"
import script from "./Barrage.vue?vue&type=script&lang=js&"
export * from "./Barrage.vue?vue&type=script&lang=js&"
import style0 from "./Barrage.vue?vue&type=style&index=0&id=0b2e6036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e6036",
  null
  
)

export default component.exports